<template>
  <div class="flex-col page">
    <div class="flex-col">
      <div
        class="flex-col section_4"
        :style="`background-image: url('${indexBg}')`"
      >
        <div class="flex-row items-end">
          <div class="flex-col justify-start items-center shrink-0 text-wrapper">
            <span class="font_4 text_7">站内查询</span>
          </div>
          <div class="flex-col justify-start flex-1 relative group_4">
            <el-input autofocus class="btn-search" v-model="search" placeholder="请输入关键字" @keyup.enter.native="handleSearch" />
            <img
              class="image_3 pos_2"
              :src="indexSearch"
              @click="handleSearch"
            />
          </div>
        </div>
        <div class="mt-10 flex-row items-center">
          <p v-for="(item, index) in searchTypes" class="item" :class="{active: curType === item.id}" :key="index" @click="handleSelectType(item)">{{item.name}}</p>
        </div>
      </div>
    </div>
    <div class="mt-44 flex-col">
      <div class="flex-col group_5">
        <div class="flex-row group_6">
          <div
            class="flex-col shrink-0 section_6"
          >
            <div class="lunbo">
              <el-carousel indicator-position="outside">
                <el-carousel-item v-for="item in calcNewsData" :key="item">
                  <div>
                    <img class="img" :src="item.src" :alt="item.key" />
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
          <div class="flex-col flex-1 ml-25">
            <div class="flex-row justify-between items-center self-stretch section_7">
              <span v-for="(item, index) in newsTypes" class="font_7" :class="{active: item.id === curNewsSelected}" :key="index" @click="changeNews(item)">{{item.name}}</span>
            </div>
            <div class="row-box">
              <p v-for="(item, index) in newsData" class="row" :key="index" @click="goNews(item)">
                <span class="key">{{item.key}}</span>
                <span v-if="index === 0" class="time-box">
                  <span class="date">{{item.value.slice(8, 10)}}</span>
                  <span class="month">{{item.value.slice(0, 7)}}</span>
                </span>
                <span v-else class="value">{{item.value}}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="flex-col group_12">
          <div class="flex-row items-center section_8">
            <div
              v-for="(item, index) in systemServerTypeData"
              class="flex-col justify-start items-center text-wrapper_5"
              :class="{active: curSystemServerType === item.id}"
              :style="curSystemServerType === item.id && `background-image: url('${$images.indexDot}')`"
              :key="index"
              @click="setSystemServerType(item)"
            >
              <span class="font_10 text_22">{{item.name}}</span>
            </div>
          </div>
          <div class="mt-16 flex-row equal-division">
            <template v-for="(item, index) in sysServerList[curSystemServerType]">
            <div v-if="index === 0" :key="index" class="flex-col justify-start items-start equal-division-item text-wrapper_6"
                 :style="`background-image: url('${$images.applyImg1}')`"
                 @click="goLink(item)"
            >
              <span class="font_11 text_24">{{item.name}}</span>
            </div>
            <div v-if="index === 1" :key="index" class="ml-36 flex-col justify-start items-start equal-division-item text-wrapper_7"
                 :style="`background-image: url('${$images.applyImg2}')`"
                 @click="goLink(item)"
            >
              <span class="font_11 text_25">{{item.name}}</span>
            </div>
            <div v-if="index === 2" :key="index" class="ml-36 flex-col justify-start items-start equal-division-item text-wrapper_8"
                 :style="`background-image: url('${$images.applyImg3}')`"
                 @click="goLink(item)"
            >
              <span class="font_11 text_26">{{item.name}}</span>
            </div>
            </template>
          </div>
        </div>
        <div class="flex-col group_13 view">
          <div class="flex-row group_14">
            <div class="flex-row justify-between items-center section_9">
              <div class="flex-col justify-start items-center text-wrapper_9">
                <span class="font_12 text_27">技术标准</span>
              </div>
              <span class="font_13 text_28" @click="goLink({link: '/catalog?type=5'})">更多</span>
            </div>
            <div class="flex-row justify-between items-center section_9 view_2 ml-21">
              <div class="flex-col justify-start items-center text-wrapper_10">
                <span class="font_12 text_27">认证规则</span>
              </div>
              <span class="font_13 text_28" @click="goLink({link: '/catalog?type=6'})">更多</span>
            </div>
          </div>
          <div class="flex-row justify-between group_14 view_3">
            <div class="row-list">
              <div v-for="(item, index) in technologyStandardData" class="row" :key="index" @click="goCatalog(item)">
                <span class="font_8">{{item.name}}</span>
                <span class="font_9">{{item.time}}</span>
              </div>
            </div>
            <div class="row-list">
              <div v-for="(item, index) in authenticationRuleData" class="row" :key="index" @click="goCatalog(item, '228')">
                <span class="font_8">{{item.name}}</span>
                <span class="font_9">{{item.time}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-col group_13 view_5">
          <div class="flex-row justify-between items-center self-stretch section_8">
            <div class="flex-col justify-start items-center text-wrapper_11">
              <span class="font_12 text_36">服务机构</span>
            </div>
            <!--<span class="font_13 text_37">更多</span>-->
          </div>
          <div class="grid">
            <div v-for="(item, index) in serverList" class="flex-col items-center grid-item_2" :key="index" @click="goNewLink(item)">
              <span class="img-box">
                <img
                  class="image_12"
                  :src="item.src"
                />
              </span>
              <span class="mt-38 font_14 text text_39">{{item.name}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    const {
      indexBg,
      indexSearch
    } = this.$images
    return {
      indexBg,
      indexSearch,
      search: '',
      curType: '',
      searchTypes: [
        { id: '224', name: '新闻资讯' },
        { id: '225', name: '政策法规' },
        { id: '226', name: '信息发布' },
        { id: 4, name: '机构查询' },
        { id: 5, name: '证书/报告查询' }
      ],
      curNewsSelected: '2',
      newsTypes: [
        { id: '2', name: '新闻资讯' },
        { id: '3', name: '政策法规' },
        { id: '4', name: '信息发布' }
      ],
      newsData: [
        // { id: '1', key: '某某信息某某信息某某信息', value: '2024-10-20' },
        // { id: '1', key: '某某信息某某信息某某信息', value: '2024-10-20' },
        // { id: '1', key: '某某信息某某信息某某信息', value: '2024-10-20' },
        // { id: '1', key: '某某信息某某信息某某信息', value: '2024-10-20' },
        // { id: '1', key: '某某信息某某信息某某信息', value: '2024-10-20' },
        // { id: '1', key: '某某信息某某信息某某信息', value: '2024-10-20' }
      ],
      newsData1: [
      ],
      curSystemServerType: '1',
      systemServerTypeData: [
        { id: '1', name: '系统服务申请入口' },
        { id: '2', name: '系统服务查询入口' }
      ],
      sysServerList: {
        1: [
          { name: '机构申请', link: '/server?type=7&id=1' },
          { name: '项目申请', link: '/server?type=8&id=1' },
          { name: '证书/报告备案申请', link: '/server?type=9&id=1' }
        ],
        2: [
          { name: '机构查询', link: '/server?type=7&id=2' },
          { name: '项目查询', link: '/server?type=7&id=2' },
          { name: '证书/报告备案查询', link: '/server?type=9&id=2' }
        ]
      },
      technologyStandardData: [
        // { type: 5, id: 1, name: '认证证书和认证标志管理办法》（总局令第63号，根据总根据总局令第根据总局令第', time: '2020-1-10' },
        // { type: 5, id: 1, name: '认证证书和认证标志管理办法》（总局令第63号，根据总根据总局令第根据总局令第', time: '2020-1-10' },
        // { type: 5, id: 1, name: '认证证书和认证标志管理办法》（总局令第63号，根据总根据总局令第根据总局令第', time: '2020-1-10' },
        // { type: 5, id: 1, name: '认证证书和认证标志管理办法》（总局令第63号，根据总根据总局令第根据总局令第', time: '2020-1-10' },
        // { type: 5, id: 1, name: '认证证书和认证标志管理办法》（总局令第63号，根据总根据总局令第根据总局令第', time: '2020-1-10' },
        // { type: 5, id: 1, name: '认证证书和认证标志管理办法》（总局令第63号，根据总根据总局令第根据总局令第', time: '2020-1-10' }
      ],
      authenticationRuleData: [
        // { type: 6, id: 1, name: '认证证书和认证标志管理办法》（总局令第63号，根据总根据总局令第根据总局令第', time: '2020-1-10' },
        // { type: 6, id: 1, name: '认证证书和认证标志管理办法》（总局令第63号，根据总根据总局令第根据总局令第', time: '2020-1-10' },
        // { type: 6, id: 1, name: '认证证书和认证标志管理办法》（总局令第63号，根据总根据总局令第根据总局令第', time: '2020-1-10' },
        // { type: 6, id: 1, name: '认证证书和认证标志管理办法》（总局令第63号，根据总根据总局令第根据总局令第', time: '2020-1-10' },
        // { type: 6, id: 1, name: '认证证书和认证标志管理办法》（总局令第63号，根据总根据总局令第根据总局令第', time: '2020-1-10' },
        // { type: 6, id: 1, name: '认证证书和认证标志管理办法》（总局令第63号，根据总根据总局令第根据总局令第', time: '2020-1-10' }
      ],
      serverList: [
        // { name: '西安高压电器研究院股份有限公司', src: this.$images.indexItemLogo },
        // { name: '西安高压电器研究院股份有限公司', src: this.$images.indexItemLogo },
        // { name: '西安高压电器研究院股份有限公司', src: this.$images.indexItemLogo },
        // { name: '西安高压电器研究院股份有限公司', src: this.$images.indexItemLogo },
        // { name: '西安高压电器研究院股份有限公司', src: this.$images.indexItemLogo },
        // { name: '西安高压电器研究院股份有限公司', src: this.$images.indexItemLogo },
        // { name: '西安高压电器研究院股份有限公司', src: this.$images.indexItemLogo },
        // { name: '西安高压电器研究院股份有限公司', src: this.$images.indexItemLogo }
      ]
    }
  },
  created () {
    this.init()
  },
  computed: {
    calcNewsData () {
      return this.newsData1.slice(0, 2)
    }
  },
  methods: {
    init () {
      // 获取新闻资讯
      this.getNewsData(224, true)
      // 获取技术标准
      this.getTechnologyStandardData()
      // 获取认证规则
      this.getAuthenticationRuleData()
      // 获取服务机构
      this.getServerList()
      // 获取友情链接
      this.getFriendList()
    },
    // 跳转搜索页面
    handleSearch () {
      this.$router.push({
        path: `/search?key=${this.search}&type=${this.curType}`
      })
    },
    async getNewsData (type, isNews) {
      const enumType = {
        224: 2,
        225: 3,
        226: 4
      }
      const res = await this.$https.getList({
        page: 1,
        limit: 6,
        modeId: type
      })
      this.newsData = res.data.data.list.map(v => {
        return {
          id: v.id,
          key: v.title,
          value: v.create_time_date,
          src: v.coverPath,
          type: enumType[type]
        }
      })
      if (isNews) {
        this.newsData1 = JSON.parse(JSON.stringify(this.newsData))
      }
    },
    async getTechnologyStandardData () {
      const res = await this.$https.getList({
        page: 1,
        limit: 6,
        modeId: 227
      })
      this.technologyStandardData = res.data.data.list.map(v => {
        return {
          id: v.id,
          name: v.title,
          time: v.create_time_date,
          type: 5
        }
      })
    },
    async getAuthenticationRuleData () {
      const res = await this.$https.getList({
        page: 1,
        limit: 6,
        modeId: 228
      })
      this.authenticationRuleData = res.data.data.list.map(v => {
        return {
          id: v.id,
          name: v.title,
          time: v.create_time_date,
          type: 6
        }
      })
    },
    async getServerList () {
      const res = await this.$https.getFwjgList({
        page: 1,
        limit: 8
      })
      this.serverList = res.data.data.list.map(v => {
        return {
          name: v.name,
          src: v.coverPath,
          link: v.link
        }
      })
    },
    goCatalog (item, typeValue) {
      if (typeValue === '228' && !this.$store.state.isRuleDetail) {
        return this.$message.warning('暂未开放')
      }
      const { type, id } = item
      this.$router.push({ path: `/catalog?type=${type}&id=${id}` })
    },
    goLink (item) {
      const { link } = item
      this.$router.push({ path: link })
    },
    goNewLink (item) {
      const { link } = item
      window.open(link, '_blank')
    },
    setSystemServerType (item) {
      const { id } = item
      this.curSystemServerType = id
    },
    // 切换新闻咨询
    changeNews (item) {
      const { id } = item
      this.curNewsSelected = id
      // 请求资讯公告
      const config = {
        2: 224,
        3: 225,
        4: 226
      }
      this.getNewsData(config[id])
    },
    handleSelectType (item) {
      const { id } = item
      console.log('id==>', id)
      // 机构查询
      if (id === 4) {
        this.$EventBus.$emit('onMenuSelected', '7')
        return this.$router.push({ path: '/server?type=7&id=2' })
      }
      // 证书/报告查询
      if (id === 5) {
        this.$EventBus.$emit('onMenuSelected', '9')
        return this.$router.push({ path: '/server?type=9&id=2' })
      }
      this.curType = id
    },
    // 跳转到新闻资讯
    goNews (item) {
      const { id } = item
      this.$router.push({ path: `/consultation?type=${this.curNewsSelected}&id=${id}` })
    }
  }
}
</script>

<style scoped lang="less">

  .row-list{
    display: flex;
    flex-direction: column;
    width: 691.5px;

    .row{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: 54px;
      line-height: 54px;
      cursor: pointer;
      opacity: 1;
      cursor: pointer;

      &:hover{
        opacity: .5;
      }

      .font_8{
        width: 500px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .font_9{
        margin-right: 15px;
      }
    }
  }

  .lunbo {
    width: 590px;
    height: 446px;
    overflow: hidden;

    .img{
      height: 446px;
      object-fit: cover;
      width: 100%;
    }

    /deep/ .el-carousel--horizontal {
      overflow-x: initial;
      height: 100%;
    }
    /deep/ .el-carousel__container{
      height: 100%;
    }
    /deep/ .el-carousel__indicators--outside{
      position: absolute;
      left: 20px;
      bottom: 0px;
    }

    /deep/ .el-carousel__button{
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: white;
    }
    /deep/ .el-carousel__indicators--outside .el-carousel__indicator button{
      opacity: 1;
    }

    /deep/ .el-carousel__indicators--outside .el-carousel__indicator.is-active button{
      background: #006ED1;
    }
  }

  .row-box{
    display: flex;
    flex-direction: column;

    .row{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      height: 60px;
      line-height: 60px;
      border-bottom: 1px solid #dbdbdb;
      margin: 0px;
      font-size: 16px;
      cursor: pointer;
      opacity: 1;

      &:hover{
        opacity: .5;
      }

      &:nth-child(1) {
        border-bottom-color: #006ed1;
        margin-top: 20px;
        height: 80px;
        line-height: 80px;
        align-items: center;

        .key {
          font-size: 22px;
        }
      }

      .key{
        color: #333;
      }
      .value{
        color: #999;
      }
      .time-box{
        display: flex;
        flex-direction: column;
        line-height: 24px;
        align-items: center;

        .date{
          font-weight: bold;
          font-size: 26px;
          color: #006ED1;
          line-height: 22px;
        }
        .month{
          font-family: PingFang;
          font-weight: bold;
          font-size: 18px;
          color: #006ED1;
          line-height: 22px;
          margin-top: 10px;
        }
      }

      &:last-child{
        border-bottom: none;
      }
    }
  }

  .items-center {
  .item{
  color: white;
  padding: 5px 20px;
  margin-right: 10px;
  cursor: pointer;

  &.active{
  background-color: #006ed1;
  }
  }
  }
  .btn-search{
  height: 69px;

  /deep/ input{
  height: 69px;
  line-height: 69px;
  border-radius: 0px;
  font-size: 20px;
  color: #323232;
  }
  }
  .ml-5 {
  margin-left: 5px;
  }
  .ml-65 {
  margin-left: 65px;
  }
  .ml-23 {
  margin-left: 23px;
  }
  .ml-69 {
  margin-left: 69px;
  }
  .mt-187 {
  margin-top: 187px;
  }
  .ml-25 {
  margin-left: 25px;
  }
  .ml-270 {
  margin-left: 270px;
  }
  .ml-21 {
  margin-left: 21px;
  }
  .ml-37 {
  margin-left: 37px;
  }
  .ml-17 {
  margin-left: 17px;
  }
  .ml-147 {
  margin-left: 147px;
  }
  .ml-3 {
  margin-left: 3px;
  }
  .ml-45 {
  margin-left: 45px;
  }
  .page {
  background-color: #ffffff;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  .section {
  padding: 52px 0 47px;
  background-color: #ffffff;
  .text_2 {
  color: #004290;
  font-size: 39px;
  font-family: Swiss721BT;
  font-weight: 900;
  line-height: 29px;
  }
  .text_3 {
  color: #004290;
  font-size: 32px;
  font-family: Alibaba;
  line-height: 34px;
  }
  }
  .section_2 {
  padding-left: 386px;
  padding-right: 379px;
  background-color: #006ed1;
  .group_2 {
  margin-left: 85px;
  }
  .group_3 {
  margin-left: 80px;
  }
  .image {
  width: 13px;
  height: 8px;
  }
  .group {
  margin-left: 81px;
  .section_3 {
  padding: 24px 14px 24px 27px;
  background-color: #004290;
  height: 64px;
  }
  }
  .font_2 {
  font-size: 16px;
  font-family: PingFang;
  line-height: 16px;
  color: #ffffff;
  }
  .text_4 {
  line-height: 17px;
  }
  .text_5 {
  line-height: 15px;
  }
  }
  .section_4 {
  padding: 0 384px 82px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .text-wrapper {
  padding: 25px 0;
  background-color: #004290;
  width: 171px;
  height: 69px;
  .text_7 {
  color: #ffffff;
  line-height: 19px;
  }
  }
  .group_4 {
  padding-top: 116px;
  .text-wrapper_2 {
  margin-right: 43px;
  padding: 25px 0;
  background-image: url('https://ide.code.fun/api/image?token=671290ea829f510014d9d592&name=b14e678e653d606d2b54c5a2af5198ef.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .text_8 {
  margin-left: 25px;
  color: #999999;
  line-height: 19px;
  }
  }
  .image_3 {
  width: 69px;
  height: 69px;
  }
  .pos_2 {
  position: absolute;
  right: 0;
  bottom: 0;
  cursor: pointer;
  }
  .section_5 {
  padding: 20px 0 27px;
  background-color: #ffffff;
  width: 131px;
  border-left: solid 1px #006ed1;
  border-right: solid 1px #006ed1;
  border-top: solid 1px #006ed1;
  border-bottom: solid 1px #006ed1;
  .text_6 {
  color: #006ed1;
  }
  .image_2 {
  width: 69px;
  height: 2px;
  }
  .font_3 {
  font-size: 18px;
  font-family: PingFang;
  line-height: 18px;
  color: #666666;
  }
  }
  .pos {
  position: absolute;
  right: 329px;
  top: 0;
  }
  }
  .font_4 {
  font-size: 20px;
  font-family: PingFang;
  letter-spacing: -0.5px;
  line-height: 18px;
  }
  .text-wrapper_3 {
  padding: 9px 0 6px;
  background-color: #006ed1;
  width: 104px;
  height: 33px;
  }
  .font_5 {
  font-size: 18px;
  font-family: PingFang;
  letter-spacing: -0.5px;
  line-height: 18px;
  color: #ffffff;
  }
  .font_6 {
  font-size: 18px;
  font-family: PingFang;
  letter-spacing: -0.5px;
  line-height: 16px;
  color: #ffffff;
  }
  .text_9 {
  line-height: 17px;
  }
  .text_10 {
  line-height: 17px;
  }
  }
  .font {
  font-size: 18px;
  font-family: PingFang;
  line-height: 18px;
  color: #ffffff;
  }
  .group_5 {
  // padding: 0 240px 16px;
  margin: 0px auto;
  width: 1440px;
  .group_6 {
  padding-left: 7px;
  padding-right: 4px;
  .section_6 {
  /*padding: 127px 22px 11px 28px;*/
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 446px;
  .text_14 {
  color: #ffffff;
  font-size: 36px;
  font-family: lianmengqiyilushuaizhengruiheiti;
  line-height: 37px;
  letter-spacing: 7px;
  }
  .text_18 {
  color: #ffffff;
  font-size: 20px;
  font-family: PingFang;
  line-height: 20px;
  }
  .text_20 {
  margin-top: 12px;
  color: #ffffff;
  font-size: 13px;
  font-family: MicrosoftYaHei;
  line-height: 10px;
  }
  .image_5 {
  margin-left: 5px;
  margin-top: 27px;
  width: 24px;
  height: 9px;
  }
  }
  .section_7 {
  /*padding: 0 99px;*/
  background-color: #f4f4f4;
  .font_7 {
    width: 268px;
    heigt: 51px;
    font-size: 18px;
    font-family: PingFang;
    line-height: 51px;
    color: #333333;
    text-align: center;
    cursor: pointer;

    &:hover{
      color: #006ed1;
    }

    &.active{
      background-color: #006ed1;
      color: white;
    }
  }
  .text-wrapper_4 {
  padding: 16px 0;
  background-color: #006ed1;
  width: 268px;
  height: 51px;
  }
  }
  .text_11 {
  margin-right: 45px;
  margin-top: 33px;
  color: #006ed1;
  font-size: 26px;
  font-family: PingFang;
  font-weight: 700;
  line-height: 21px;
  }
  .text_12 {
  color: #333333;
  font-size: 22px;
  font-family: PingFang;
  line-height: 23px;
  }
  .text_13 {
  margin-right: 26px;
  color: #006ed1;
  font-size: 18px;
  font-family: PingFang;
  line-height: 14px;
  }
  .group_7 {
  margin-top: 15px;
  padding: 24px 10px 20px;
  border-top: solid 1px #006ed1;
  .text_15 {
  margin-right: 9px;
  line-height: 12px;
  }
  }
  .image_4 {
  margin-left: 3px;
  margin-right: 6px;
  width: 804px;
  height: 2px;
  }
  .group_8 {
  padding: 26px 2px 21px;
  .text_16 {
  margin-right: 14px;
  }
  }
  .group_10 {
  padding: 22px 2px;
  border-bottom: solid 1px #dbdbdb;
  .text_19 {
  margin-right: 14px;
  }
  }
  .group_11 {
  padding: 23px 9px 0;
  .text_21 {
  margin-right: 7px;
  }
  }
  }
  .group_12 {
  margin-top: 45px;
  .equal-division {
  margin-left: 5px;
  margin-right: 8px;
  .equal-division-item {
  flex: 1 1 452px;
  .text_24 {
  margin-left: 42px;
  }
  .text_25 {
  margin-left: 42px;
  }
  .text_26 {
  margin-left: 42px;
  }
  }
  .text-wrapper_6 {
  padding: 52px 0 56px;
  border-radius: 5px;
  background-image: url('https://ide.code.fun/api/image?token=671290ea829f510014d9d592&name=b7c817f8f2793504eae62ec0918ee8bd.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 132px;
    cursor: pointer;
    flex-shrink: 0;
  }
  .text-wrapper_7 {
  padding: 52px 0 56px;
  border-radius: 5px;
  background-image: url('https://ide.code.fun/api/image?token=671290ea829f510014d9d592&name=dcea96e1e36f3285ce4aab72e43b7157.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 132px;
    cursor: pointer;
  }
  .text-wrapper_8 {
  padding: 52px 0 56px;
  border-radius: 5px;
  background-image: url('https://ide.code.fun/api/image?token=671290ea829f510014d9d592&name=b53cf8987ca7d2be15a3947524f277f4.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 132px;
    cursor: pointer;
  }
  }
  }
  .group_13 {
  padding: 0 4px;
  .group_14 {
  padding: 0 2px;
  .section_9 {
  flex: 1 1 705px;
  background-color: #f4f4f4;
  height: 47px;
  .text-wrapper_9 {
  padding: 14px 0;
  background-color: #006ed1;
  width: 118px;
  height: 46px;
  }
  .text_28 {
  margin-right: 18px;
    cursor: pointer;

    &:hover{
      color: #006ed1;
    }
  }
  .text-wrapper_10 {
  padding: 14px 0;
  background-color: #006ed1;
  width: 121px;
  height: 46px;
  }
  .text_27 {
  line-height: 17px;
  }
  }
  .view_2 {
  margin-right: 4px;
  }
  .text_29 {
  margin-right: 17px;
  }
  .image_6 {
  width: 695px;
  height: 2px;
  }
  .image_7 {
  margin-right: 5px;
  }
  .image_8 {
  margin-right: 5px;
  }
  .image_9 {
  margin-right: 5px;
  }
  .image_10 {
  margin-right: 5px;
  }
  .image_11 {
  margin-right: 5px;
  }
  }
  .view_3 {
  margin-top: 19px;
  }
  .view_4 {
  margin-top: 21px;
  }
  .group_15 {
  padding: 27px 2px 21px;
  .text_31 {
  line-height: 12px;
  }
  .text_32 {
  margin-right: 17px;
  line-height: 12px;
  }
  }
  .group_16 {
  padding: 22px 2px 0;
  .text_35 {
  margin-right: 17px;
  }
  }
  .font_12 {
  font-size: 18px;
  font-family: PingFang;
  line-height: 16px;
  color: #ffffff;
  }
  .font_13 {
  font-size: 16px;
  font-family: PingFang;
  line-height: 16px;
  color: #999999;
  }
  .grid {
  margin: 28px 13px 0 8px;
  height: 571px;
  display: grid;
  grid-template-rows: repeat(2, minmax(0, 1fr));
  grid-template-columns: repeat(4, minmax(0, 1fr));
  row-gap: 32px;
  column-gap: 30px;
  .grid-item {
  padding: 44px 0;
  background-color: #ffffff;
  box-shadow: 1px -6px 26px #006ed159;
  border-top: solid 4px #006ed1;
  .text_40 {
  color: #006ed1;
  font-size: 17px;
  line-height: 15px;
  }
  }
  .grid-item_2 {
  padding: 43px 0 49px;
  background-color: #ffffff;
  transition: all .1s linear;
    cursor: pointer;

    &:hover{
      box-shadow: 1px -6px 26px #006ed159;
      border-top: solid 4px #006ed1;

      .text{
        color: #006ed1;
      }
    }

  .text_39 {
  font-size: 17px;
  line-height: 15px;
  }
  }
  .img-box{
    display: flex;
    width: 253px;
    height: 124px;
    justify-content: center;
    align-items: center;
  }
  .image_12 {
  }
  .font_14 {
  font-size: 16px;
  font-family: PingFang;
  letter-spacing: 1px;
  line-height: 16px;
  color: #333333;
  }
  .grid-item_3 {
  padding: 204px 0 49px;
  background-color: #ffffff;
  .text_38 {
  font-size: 17px;
  }
  }
  .grid-item_5 {
  padding: 40px 0 49px;
  background-color: #ffffff;
  .text_42 {
  font-size: 17px;
  }
  }
  .grid-item_6 {
  padding: 200px 0 20px;
  background-color: #ffffff;
  .group_17 {
  line-height: 24px;
  text-align: center;
  .font_15 {
  font-size: 16px;
  font-family: PingFang;
  letter-spacing: 1px;
  line-height: 23px;
  color: #333333;
  }
  .text_41 {
  font-size: 17px;
  line-height: 24px;
  }
  .text_44 {
  font-size: 17px;
  line-height: 24px;
  }
  }
  }
  .grid-item_4 {
  padding: 205px 0 48px;
  background-color: #ffffff;
  .text_43 {
  font-size: 17px;
  }
  }
  }
  .image_13 {
  margin-left: 22px;
  width: 26px;
  height: 26px;
  }
  }
  .view {
  margin-top: 54px;
  }
  .font_9 {
  font-size: 16px;
  font-family: PingFang;
  line-height: 13px;
  color: #999999;
  }
  .group_9 {
  padding: 22px 2px;
  .text_17 {
  margin-right: 14px;
  }
  .text_30 {
  margin-right: 17px;
  }
  .text_33 {
  line-height: 12px;
  }
  .text_34 {
  line-height: 12px;
  }
  }
  .view_5 {
  margin-top: 63px;
  }
  .section_8 {
  background-color: #f4f4f4;
  .text-wrapper_5 {
  padding: 29px 0 25px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 722px;
  height: 73px;
    cursor: pointer;

    &:hover{
      .text_22{
        color: #006ed1;
      }
    }

    &.active{
      .text_22{
        color: white;
      }
    }
  .text_22 {
  color: #323232;
  line-height: 19px;
  }
  }
  .text_23 {
  color: #333333;
  line-height: 19px;
  }
  .text-wrapper_11 {
  padding: 14px 0;
  background-color: #006ed1;
  width: 113px;
  height: 46px;
  .text_36 {
  line-height: 17px;
  }
  }
  .text_37 {
  margin-right: 21px;
  }
  }
  }
  .text {
  text-transform: uppercase;
  }
  .font_8 {
  font-size: 16px;
  font-family: PingFang;
  line-height: 16px;
  color: #333333;
  }
  .section_11 {
  padding: 8px 0 39px;
  background-image: url('https://ide.code.fun/api/image?token=671290ea829f510014d9d592&name=8f5fa3349de83b3580a442dad4434fb8.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .group_19 {
  padding: 106px 360px 30px;
  height: 188px;
  .image_15 {
  width: 40px;
  height: 43px;
  }
  .pos_4 {
  position: absolute;
  left: 362px;
  bottom: 38px;
  }
  .font_16 {
  font-size: 16px;
  font-family: PingFang;
  line-height: 16px;
  color: #b2b3b8;
  }
  .text_46 {
  line-height: 15px;
  }
  .pos_5 {
  position: absolute;
  left: 419px;
  bottom: 66px;
  }
  .pos_6 {
  position: absolute;
  left: 734px;
  bottom: 66px;
  }
  .text_47 {
  color: #006ed1;
  font-size: 24px;
  font-family: PingFang;
  font-weight: 700;
  line-height: 20px;
  }
  .pos_10 {
  position: absolute;
  left: 418px;
  bottom: 34px;
  }
  .image_17 {
  width: 48px;
  height: 36px;
  }
  .pos_9 {
  position: absolute;
  left: 673px;
  bottom: 39px;
  }
  .pos_7 {
  position: absolute;
  right: 834px;
  bottom: 66px;
  }
  .text_48 {
  color: #006ed1;
  }
  .pos_11 {
  position: absolute;
  left: 735px;
  bottom: 30px;
  }
  .image_16 {
  width: 31px;
  height: 43px;
  }
  .pos_8 {
  position: absolute;
  right: 877px;
  bottom: 37px;
  }
  .group_20 {
  width: 1326px;
  .group_21 {
  margin-top: 39px;
  .image_14 {
  width: 41px;
  height: 41px;
  }
  .text_45 {
  color: #b2b3b8;
  }
  }
  .text_49 {
  margin-top: 136px;
  color: #006ed1;
  line-height: 19px;
  }
  .section_12 {
  background-color: #2e3141;
  width: 204px;
  height: 188px;
  }
  }
  .pos_3 {
  position: absolute;
  right: 234px;
  top: 0;
  }
  }
  .group_22 {
  padding: 0 360px;
  .font_17 {
  font-size: 14px;
  font-family: PingFang;
  line-height: 11px;
  color: #939598;
  }
  }
  }
  .font_11 {
  font-size: 24px;
  font-family: PingFang;
  line-height: 23px;
  color: #004290;
  }
  .font_10 {
  font-size: 20px;
  font-family: PingFang;
  line-height: 18px;
  }
  }
</style>
